import { useEffect, useRef, useState } from 'react';
import { Button, Flex, Input, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useGetVehicleByCode } from '@features/vehicles/hooks/useVehicleData';

const { Text } = Typography;

export const InputFasecoldaCode = ({ value, disabled, onChange, onVehicleByFasecoldaCodeQuery }) => {
  const [fasecoldaCode, setFasecoldaCode] = useState('');
  const [searchStatus, setSearchStatus] = useState(null); // null | 'success' | 'error'
  const hasSearched = useRef(false);

  const { data, isFetching, isError, error, refetch } = useGetVehicleByCode(fasecoldaCode, { enabled: false });

  useEffect(() => {
    if (disabled) setSearchStatus(null);
  }, [disabled]);

  const handleChange = (e) => {
    setFasecoldaCode(e.target.value);
    setSearchStatus(null);
    hasSearched.current = false;
    onChange?.(e);
  };

  const handleSearch = () => {
    if (!fasecoldaCode) return;
    hasSearched.current = true;
    refetch();
  };

  useEffect(() => {
    if (!hasSearched.current) return;
    if (!isFetching) {
      setSearchStatus(isError ? 'error' : 'success');
    }
    onVehicleByFasecoldaCodeQuery?.({ data, isFetching, isError, error, refetch });
  }, [data, isFetching, isError, error, refetch]);

  return (
    <Flex vertical gap={6}>
      <Flex gap={8}>
        <Input
          style={{ flex: 1 }}
          value={value}
          placeholder={disabled ? 'Código Fasecolda' : 'Ingresar código Fasecolda'}
          onChange={handleChange}
          onPressEnter={handleSearch}
          readOnly={isFetching}
          disabled={disabled}
        />
        <Button
          type='primary'
          icon={<SearchOutlined />}
          onClick={handleSearch}
          loading={isFetching}
          disabled={disabled}
        >
          Buscar
        </Button>
      </Flex>
      {searchStatus === 'success' && (
        <Text type='success' style={{ fontSize: '0.9em' }}>
          Información encontrada correctamente
        </Text>
      )}
      {searchStatus === 'error' && (
        <Text type='danger' ellipsis={{ tooltip: { color: 'red' } }} style={{ fontSize: '0.9em' }}>
          El código Fasecolda no fue encontrado
        </Text>
      )}
    </Flex>
  );
};
